import React from 'react'

function StepIndicator({ index = 0, steps = 3 }) {
  const safeSteps = Math.max(2, steps);
  const children = [];
  for (let i = 0; i < safeSteps; i += 1) {
    children.push(
      <div key={`item-${i}`} className={`step-indicator-item ${index >= i ? 'indicator-active' : ''}`}>
        <i className="fa fa-check"></i>
      </div>
    );
    if (i < safeSteps - 1) {
      children.push(
        <div key={`spacer-${i}`} className={`step-indicator-spacer ${index > i ? 'spacer-active' : ''} `}>
          <div className="spacer-inside"></div>
        </div>
      );
    }
  }
  return <div className="step-indicator">{children}</div>;
}

export default StepIndicator